<template>
  <div style="margin-top:30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="标题"
        prop="title"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.title"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item
        label="内容"
        prop="content"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="3"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item
        label="类型"
        prop="type"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.type"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(v,k) in dicts.bannerType"
            :key="k"
            :label="v"
            :value="k"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="链接"
        prop="url"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.url"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item
        label="图片"
        style="margin-right:15px"
        :required="true"
      >
        <ImgUpload
          :upload-config="{ lebal: '轮播图片', prefix: 'img', form, suffix: '', modal: false }"
          :parent-data="{ isDetail: false }"
          isicon
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgUpload from "@/components/ImgUpload";

export default {
  name: 'BannerEdit',
  components: {
    ImgUpload
  },
  data() {
    return {
      dicts: { bannerType: {}},
      emptyForm: {},
      form: {
        code: '',
        branchCode: '',
        title: '',
        content: '',
        img: '',
        type: '',
        url: '',
        status: ''
      },
      rules: {
         title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' },

        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50个字符', trigger: 'blur' },
        ],
        content: [
          { min: 1, max: 255, message: '长度在 1 到 255字符', trigger: 'blur' },
        ],
         url: [
          { min: 1, max: 255, message: '长度在 1 到 255个字符', trigger: 'blur' },
        ],
     }


    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code, dicts) {
      this.dicts = dicts
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.$refs['form'].resetFields()
      request({ url: `/ntocc-basic-api/banner/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/banner', method: 'put', params: data }).then(response => {
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherEditMethod')
            rLoading.close();
            if(this.form.type=="subscript"){
               document.querySelector('link[rel="icon"').href = this.form.img
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'edit')
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
